module.exports = __webpack_public_path__ + "img/add-contact.d343de0f.svg";